import map from 'lodash/map'
import { useCallback, useContext } from 'react'

import { AddToCartLegacyProductPersonalizationInput, AddToCartLegacyResponse, useAddToCartLegacyMutation } from '@Generated/graphql'
import { MetadataContext } from '@Globals/Metadata'

type AddToCartProps = {
  additionalProductIDs?: string[]
  personalization?: AddToCartLegacyProductPersonalizationInput
  productID: string
  quantity?: number
}

// TODO: merge functionality into useAddToCartQuery
export const useAddToCartQuery = () => {
  const { storeURL } = useContext(MetadataContext)
  const [doAddToCart] = useAddToCartLegacyMutation()

  return useCallback(async ({
    additionalProductIDs,
    personalization,
    productID,
    quantity = 1,
  }: AddToCartProps) => {
    // Make sure we have the correct cookies and stuff. This is hella fast, and also needed, so there.
    await fetch(storeURL('/checkout/cart/initsession'), { method: 'POST', credentials: 'include' })

    const { data } = await doAddToCart({
      context: {
        domainProxy: true,
        userSpecific: true,
      },
      variables: {
        products: [
          {
            personalization,
            productID,
            quantity,
          },
          ...map(additionalProductIDs, id => ({ productID: id, quantity: 1 })),
        ],
      },
    })

    return data?.addToCartLegacy as AddToCartLegacyResponse
  }, [doAddToCart, storeURL])
}
